import React, { useEffect, useState } from 'react';
import { Link, useParams, useLocation, useOutletContext } from 'react-router-dom';
import { Api, cancelRequest } from '../../api/Assinafy';
import { Button, Icon, Viewport } from '../../components';
import CreateFreeAccount from './CreateFreeAccount';
import DocumentsSign from './DocumentsSign';
import { Container } from '../../layout';
import { SignNavbar } from '../../layout/Sign';

const DocumentSuccess = () => {
  const [, setLayoutClassName] = useOutletContext()
  const [signer, setSigner] = useState({})
  const { signerAccessCode } = useParams()
  const [documents, setDocuments] = useState([])
  const cancelToken = cancelRequest()
  const location = useLocation()
  const { state } = location

  const getDocumentName = () => {
    const documentName = state?.documentName
    if (documentName) {
      if (Array.isArray(documentName)) {
        if (documentName.length > 1) {
          return <>
            <b>{documentName.join(', ').replace(/,([^,]*)$/, ' e$1')}</b> foram assinados.
          </>
        }

        return <>
          <b>{documentName.join('')}</b> foi assinado.
        </>
      }

      return <>
        <b>{documentName}</b> foi assinado.
      </>
    }
  }

  const signNavbarContent = () => {
    return (<>
      <span className="text-secondary d-none d-lg-block">{signer.email}</span>
    </>)
  }

  useEffect(() => {
    setLayoutClassName('sign-response')

    Api('signer/self')(signerAccessCode)
      .then(({ status, data: { data } }) => {
        if (status === 200) {
          setSigner(data)
        }
      })

    return () => {
      cancelToken.cancel()
    }
  }, [])

  useEffect(() => {
    if (!Object.keys(signer).length) {
      return
    }

    Api('signer/documents')(signer.id, {
      params: {
        'per-page': 999,
        'signer-access-code': signerAccessCode,
        status: 'pending_signature'
      },
      ...cancelToken.config
    })
      .then(({ status, data: { data } }) => {
        if (status === 200) {
          data.map((document) => {
            setDocuments((prevState) => {
              if (
                document.assignment.method === 'virtual' &&
                !document.assignment.summary.signers.find(s => s.id === signer.id).completed
              ) {
                return [...prevState, document]
              }
              return prevState
            })
          })
        }
      })

    return () => {
      setDocuments([])
    }
  }, [signer])

  return (<>
    <SignNavbar toggler={false}>
      {signNavbarContent()}
    </SignNavbar>
    <Viewport>
      <Container>
        <Icon id="icon-check" className="response-icon" size="48" />
        <h2 className="h1">
          {Array.isArray(state?.documentName)
            ? 'Assinaturas feitas'
            : 'Assinatura feita'
          } com sucesso!
        </h2>
        <div className="response-opening">
          {getDocumentName()} Quando todos assinarem, você receberá um e-mail com o documento assinado.
        </div>

        {documents?.length ?
          <DocumentsSign
            total={documents.length}
            signer={signer}
            signerAccessCode={signerAccessCode}
          />
          :
          <CreateFreeAccount />
        }
      </Container>
    </Viewport>
  </>)
};

export default DocumentSuccess;
